import { DessemNiveisContingencia } from 'types/Relatorios/Dessem';

/**
 * Texto fixo do quadro "Níveis de Contingência" da aba Premissas Gerais do Informe DESSEM, como
 * veio do Planejamento (verbatim: o `°`, a `ª` e o travessão `–` fazem parte do texto). Hoje é
 * constante no front; se um dia vier de uma rota, é este o formato (`DessemNiveisContingencia`).
 */
export const NIVEIS_CONTINGENCIA_DESSEM: DessemNiveisContingencia = {
  titulo: 'Níveis de Contingência',
  intro: 'As simulações podem ser realizadas em até 3 níveis distintos de contingência, conforme viabilidade de execução do caso:',
  itens: [
    { texto: 'Sem contingência.' },
    {
      texto: '1° nível de contingência (desabilitando a função crossover) - Utilizado pelo ONS após as 16h.',
    },
    {
      texto: '2° nível de contingência (desabilitando a função crossover e desconsiderando a representação do unit commitment das UTEs) – Utilizado pelo ONS após as 16h e caso a 1ª contingência não seja viabilizada a tempo.',
      italicos: ['unit commitment'],
    },
    { texto: '3° nível de contingência – não há publicação do deck dessem.' },
  ],
};

/** Um pedaço do texto de um item: em itálico (`<em>`) ou não. */
export interface TrechoDeTexto { texto: string; italico: boolean; }

interface Ocorrencia { inicio: number; trecho: string; }

/**
 * Ocorrência mais à esquerda de qualquer um dos `trechos` a partir de `cursor`; em empate, a do
 * trecho mais longo.
 */
function proximaOcorrencia(texto: string, trechos: string[], cursor: number): Ocorrencia | null {
  return trechos.reduce<Ocorrencia | null>((melhor, trecho) => {
    const inicio = texto.indexOf(trecho, cursor);
    if (inicio === -1) return melhor;
    const ganha = !melhor || inicio < melhor.inicio
      || (inicio === melhor.inicio && trecho.length > melhor.trecho.length);
    return ganha ? { inicio, trecho } : melhor;
  }, null);
}

/**
 * Quebra `texto` nos trechos a grifar (todas as ocorrências de cada um de `italicos`), na ordem em
 * que aparecem, sem regex: `indexOf` em laço. Trecho vazio, ou que não ocorre no texto, é ignorado;
 * quando dois começam na mesma posição vale o mais longo. Não devolve pedaços vazios.
 */
export function segmentarItalicos(texto: string, italicos?: string[]): TrechoDeTexto[] {
  const trechos = (italicos ?? []).filter((trecho) => trecho.length > 0);
  const resultado: TrechoDeTexto[] = [];
  let cursor = 0;

  while (cursor < texto.length) {
    const ocorrencia = proximaOcorrencia(texto, trechos, cursor);
    const inicio = ocorrencia ? ocorrencia.inicio : texto.length;
    if (inicio > cursor) resultado.push({ texto: texto.slice(cursor, inicio), italico: false });
    if (ocorrencia) resultado.push({ texto: ocorrencia.trecho, italico: true });
    cursor = ocorrencia ? inicio + ocorrencia.trecho.length : texto.length;
  }

  return resultado;
}
